import ReorderController from './reorder_controller'

const application = window.Stimulus

application.register('reorder', ReorderController)
